// extracted by mini-css-extract-plugin
export var container = "_34-0";
export var icon = "_34-1";